export class SubmissionUpdate {
    id: string;
    latestFilename: string;
    company: string;
    companyName: string;
    legalEntity: string;
    legalEntityName: string;
    jurisdiction: string;
    returnType: string;
    periodFrom: Date;
    periodTo: Date;
    corrective: boolean;
    latestUploadedBy: string;
    latestUploadedOn: Date;
    statusCode: string;
    statusCodeIndex: number;
    submissionStatusCode: string;
    submissionStatusCodeIndex: number;
    statusUpdateImminent: boolean;

    isNew: boolean;
}